export default __webpack_public_path__ + "static/regular-cabin-bedroom-0f49f86b0e35c260d15fbb5811f079cf.jpg";